import {Component, Inject, Input, OnDestroy, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {CommonModule} from "@angular/common";
import {NgScrollbar} from "ngx-scrollbar";
import {NgSelectModule} from "@ng-select/ng-select";
import {FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslocoDirective} from "@jsverse/transloco";
import {combineLatest, debounceTime, map, Observable, Subject, take, takeUntil, tap} from "rxjs";
import {IPlaybookCategoryDTO} from "../../../dto/playbooks-listening.dto";
import {Actions, ofType} from "@ngrx/effects";
import * as PlaybooksListingActions from "../../../store/playbooks.actions";
import {PlaybooksListeningFacadeService} from "../../../store/playbooks-listening.facade.service";
import {
    IAddEditPlaybookFacade,
    IAddEditPlaybookFacadeToken
} from "../../../playbooks/add-edit-playbook/add-edit-playbook.facade";
import {ColorPickerModule} from "ngx-color-picker";
import {SharedModule} from "../../../../../shared/shared/shared.module";
import {CoreDirectivesModule} from "../../../../../../../@core/directives/directives";
import { LHSubmitFormButtonTranslationKey } from '../legal-hub-side-bar';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-legal-hub-settings-tab',
  standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslocoDirective,
        ColorPickerModule,
        SharedModule,
        CoreDirectivesModule,
        NgSelectModule
    ],
  templateUrl: './legal-hub-settings-tab.component.html',
  styleUrl: './legal-hub-settings-tab.component.scss',
})
export class LegalHubSettingsTabComponent implements OnInit, OnDestroy {
    private searchSubject: Subject<string> = new Subject<string>();
    private unsubscribe$: Subject<void> = new Subject<void>();

    @Output() public submitClicked: EventEmitter<void> = new EventEmitter<void>();

    loading$:Observable<boolean> = this._addEditPlaybookFacadeService.loading$;
    submitting$:Observable<boolean> = this._addEditPlaybookFacadeService.submitting$;

    processing$:Observable<boolean> = combineLatest([
        this._addEditPlaybookFacadeService.loading$,
        this._addEditPlaybookFacadeService.submitting$
    ]).pipe(
        map(x=> x.some(y => y === true))
    )


    @Input() playbookForm: FormGroup;
    @Input() public submitted: boolean = false;
    public queryString: string = "";
    public categories$: Observable<IPlaybookCategoryDTO[]> = this._playbooksListeningFacadeService.categoriesList$;
    public isCategoriesLoading$: Observable<boolean> = this._playbooksListeningFacadeService.isCategoriesLoading$;
    @ViewChild('guideLineScroll', {static: false}) scrollArea?: NgScrollbar;



    protected playbookId: number;


    constructor(
                 private hostFrom: FormGroupDirective,
                 private _actions$: Actions,
                 private _activeModal: NgbActiveModal,
                 private _playbooksListeningFacadeService:PlaybooksListeningFacadeService,
                 @Inject(IAddEditPlaybookFacadeToken) protected _addEditPlaybookFacadeService:IAddEditPlaybookFacade,
                 @Inject(LHSubmitFormButtonTranslationKey) public submitButtonTranslationKey: string) {
        this.playbookForm = this.hostFrom.form;
    }


    ngOnInit(): void {
        this.searchSubject.pipe(
            debounceTime(300),
            tap((queryString: string) => {
                this._playbooksListeningFacadeService.fetchCategories(queryString);
            }),
            takeUntil(this.unsubscribe$)
        ).subscribe(() => {});
        this.playbookForm = this.hostFrom.form;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }


    searchCategory(search: string) {
        this.searchSubject.next(search);
    }

    onCategorySelectionChanged(category:{id?:number, name:string}){
        if(this.isANewCategory(category)){
            this._playbooksListeningFacadeService.addNewCategory(category.name);
            this._actions$
                .pipe(
                    ofType(PlaybooksListingActions.addNewCategorySucceeded),
                    take(1)
                )
                .subscribe((action) => {
                    const newCategory = (<any>action).category;
                    this.playbookForm.get('category')?.setValue(newCategory.id);
                });
        }

    }

    closeSiderBar(){
        this._activeModal.close({refresh_listing: false});
    }

    onSubmit(){
        this.submitted = true;
        this.submitClicked.emit();
    }

    protected isANewCategory(category:{id?:number, name:string}){
        return category && Object.prototype.hasOwnProperty.call(category, 'id') === false && category?.name?.trim().length > 0
    }
}
